import {
    createTheme
} from '@mui/material/styles';
const theme = createTheme({
    breakpoints: {
        values: {
            xs: 0,
            sm: 540,
            md: 720,
            lg: 960,
            xl: 1140
        },
    },
    palette: {
        background: {
            default: '#FFFFFF',
        }
    },
    components: {
        MuiContainer: {
            defaultProps: {
                maxWidth: "xl"
            }
        }
    },
    typography:{
        allVariants:{
            color: "#2b2b2b",
            fontFamily: ['"Open sans"',"sans-serif"].join(',')
        },
        fontFamily: ['"Open sans"',"sans-serif"].join(','),
        h1:{
            fontSize: '48px !important',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '58px !important'
        },
        h3: {
            fontSize: '28px',
            fontFamily: ['"Open sans"',"serif"].join(','),
        },
        body1:{
            fontSize: '16px',
            fontStyle: 'normal',
            fontWeight: 400,
            lineHeight: '24px'
        }
    }
});

theme.typography.h1 = {
    ...theme.typography.h1,
    [theme.breakpoints.down('sm')]: {
        fontSize: '32px !important',
        lineHeight: "38px !important",
        fontWeight: '400'
    }
}

export default theme;